import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";



export const ValidationWorkAndEducationInformation = createAsyncThunk(
  "ValidationWorkAndEducationInformationRed/ValidationWorkAndEducationInformation",
  async (parameters, { rejectWithValue }) => {
    try {
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/Validation/ValidationWorkAndEducationInformation",
        parameters
      );

      const data = response.data; // Assuming response has a "data" field
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const WorkAndEducationInformationValidation = createSlice({
  name: "WorkAndEducationInformationValidation",
  initialState: {
  
    ValidationWorkAndEducationInformation: {},
    loadingValidationWorkAndEducationInformation: false,
    errorValidationWorkAndEducationInformation: null,
  },
  reducers: {
   
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        ValidationWorkAndEducationInformation.pending,
        (state, action) => {
          console.log(action.payload, "action.payload");

          state.loadingValidationWorkAndEducationInformation = true;
          state.ValidationWorkAndEducationInformation = action.payload;
          state.errorQuestionsAnswers = null;
        }
      )
      .addCase(
        ValidationWorkAndEducationInformation.fulfilled,
        (state, action) => {
          state.loadingValidationWorkAndEducationInformation = false;
          state.ValidationWorkAndEducationInformation = action.payload;
        }
      )
      .addCase(
        ValidationWorkAndEducationInformation.rejected,
        (state, action) => {
          state.loadingValidationWorkAndEducationInformation = false;
          state.errorValidationWorkAndEducationInformation = action.payload;
        }
      );
    //------------------- UpdateQuestionsAnswers -----------------------------------

  },
});

export default WorkAndEducationInformationValidation.reducer;
